/**
 * Guards against stale /api/auth/me responses racing with guid login (P0).
 * @param {{ seq: number, latestSeq: number, epochAtStart: number, currentEpoch: number, authenticated: boolean }} args
 */
export function shouldApplyCheckAuthResult({
  seq,
  latestSeq,
  epochAtStart,
  currentEpoch,
  authenticated,
}) {
  if (seq !== latestSeq) return false;
  if (epochAtStart !== currentEpoch) {
    return authenticated === true;
  }
  return true;
}
